import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/xmsb' },
    { path: '/login', name: 'Login', component: () => import('@/views/login.vue') },
    { path: '/xmsb', name: 'xmsb', component: () => import('@/views/xmsb/index.vue'), meta: { requiresAuth: false } },
    { path: '/xmsbApply', name: 'xmsbApply', component: () => import('@/views/xmsb/xmsbApply.vue'), meta: { requiresAuth: false } },
    { path: '/xmsbDetail', name: 'xmsbDetail', component: () => import('@/views/xmsb/xmsbDetail.vue'), meta: { requiresAuth: false } },
  ]
})

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

// 路由守卫
// router.beforeEach((to, from, next) => {
//   const isLogin = localStorage.getItem('isLogin') === 'true'
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // 需要登录的页面
//     if (!isLogin) {
//       next({ path: '/login' })
//     } else {
//       next()
//     }
//   } else {
//     // 访问登录页，如果已登录则跳转首页
//     if (to.path === '/login' && isLogin) {
//       next({ path: '/' })
//     } else {
//       next()
//     }
//   }
// })

export default router
